export enum ResourceSearchMode {
  All = 1,
  Root,
  Component,
  User,
}
